import moment from 'moment-timezone';
import { DRIVING_VISIT_MAX_MINUTES } from './constants';
const DRIVING_VISIT_MAX_MS = DRIVING_VISIT_MAX_MINUTES * 60 * 1000;

const parseStartDrivingTimeUtc = startDrivingTime => {
  const parsed = moment.utc(startDrivingTime);
  if (!parsed.isValid()) return null;
  return parsed.valueOf();
};
/** @param startDrivingTime UTC ISO-8601, e.g. 2026-07-13T14:59:06.486 */


export function getDrivingVisitElapsedMs(startDrivingTime) {
  if (!startDrivingTime) return null;
  const startMs = parseStartDrivingTimeUtc(startDrivingTime);
  if (startMs === null) return null;
  return Date.now() - startMs;
}
export function getDrivingVisitRemainingMs(startDrivingTime) {
  const elapsedMs = getDrivingVisitElapsedMs(startDrivingTime);
  if (elapsedMs === null) return null;
  return Math.max(0, DRIVING_VISIT_MAX_MS - elapsedMs);
}
export function isDrivingVisitExpired(startDrivingTime) {
  const elapsedMs = getDrivingVisitElapsedMs(startDrivingTime);
  if (elapsedMs === null) return false;
  return elapsedMs >= DRIVING_VISIT_MAX_MS;
}
export function calcDurationToNow(date, timeUnit) {
  const nowUtc = moment.utc().format('MM/DD/YYYY HH:mm:ss');
  const dateUtc = moment.utc(date).format('YYYY-MM-DD HH:mm:ss'); // current UTC time

  const calculatedDuration = moment(nowUtc, 'MM/DD/YYYY HH:mm:ss').diff(dateUtc, timeUnit);
  return calculatedDuration;
} // not used

export function calcDuration(startDate, endDate, timeUnit) {
  const startUtc = moment.utc(startDate).format('MM/DD/YYYY HH:mm');
  const endUtc = moment.utc(endDate).format('MM/DD/YYYY HH:mm'); // current UTC time

  const calculatedDuration = moment(endUtc, 'MM/DD/YYYY HH:mm').diff(moment(startUtc, 'MM/DD/YYYY HH:mm'), 'minutes');
  return calculatedDuration;
} // not used

export function calcDurationTimer(startDate, endDate) {
  const calculatedDuration = moment.utc(endDate).diff(moment.utc(startDate), 'minutes');
  const pastMinute = calculatedDuration ? calculatedDuration % 60 : 0;
  const pastHour = calculatedDuration ? Math.floor(calculatedDuration / 60) : 0;
  const minute = pastMinute.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  }) || '00';
  const hour = pastHour.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  }) || '00';
  return [hour, minute];
}
export function hhmmToMin(hh, mm) {
  return parseInt(hh) * 60 + parseInt(mm);
}